"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnslaughtAbilityHandler = exports.OnslaughtActorAbilityFactory = exports.OnslaughtAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
class OnslaughtAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Onslaught;
        this.__typeName = "Onslaught";
    }
}
exports.OnslaughtAbilityArgs = OnslaughtAbilityArgs;
let OnslaughtActorAbilityFactory = class OnslaughtActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Onslaught", "AllEnemies", 1);
    }
};
OnslaughtActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Onslaught")
], OnslaughtActorAbilityFactory);
exports.OnslaughtActorAbilityFactory = OnslaughtActorAbilityFactory;
let OnslaughtAbilityHandler = class OnslaughtAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                jitter: (0, Random_1.random)(25, 75),
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Holy", 50)
                ]
            })),
        });
    }
};
OnslaughtAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Onslaught)
], OnslaughtAbilityHandler);
exports.OnslaughtAbilityHandler = OnslaughtAbilityHandler;
